module.exports = __webpack_public_path__ + "static/media/es.f5311bf6.svg";